import type { Map } from 'immutable';
import { DateRange, DateTime } from '@ksyos/date-time';

type NullableDateLike = Date | string | null;

export function validateDatetimeOverlap<
    T extends {
        endDate: NullableDateLike;
        errors: Map<string, string | undefined>;
        fieldName?: string;
        startDate: NullableDateLike;
    },
>(items: T[]) {
    const result: T[] = [];

    const dateRanges = items.map((dateRange) => {
        const start = dateRange.startDate ? DateTime.from(dateRange.startDate) : DateTime.from('1900-01-01');
        const end = dateRange.endDate ? DateTime.from(dateRange.endDate) : null;

        return new DateRange(start, end);
    });

    for (let i = 0; i < dateRanges.length; i++) {
        const dateRange = { ...items[i] };

        const rangeToValidate = dateRanges[i];
        const hasOverlap = dateRanges.some(
            (otherRange) => rangeToValidate !== otherRange && rangeToValidate.hasOverlapWith(otherRange)
        );

        if (hasOverlap) {
            dateRange.errors = dateRange.errors.set(dateRange.fieldName ?? 'endDate', 'dateOverlap');
        }

        result.push(dateRange);
    }

    return result;
}
